export const STEP_REQUIREMENT = 0;
export const STEP_CHARGE = 1;

export const additionalRequirementFields = {
  Product_PlanoImage: {
    fieldDisplayName: 'Planogram Image',
    fieldName: 'product_PlanoImage',
  },

  Product_AdditionalImage: {
    fieldDisplayName: 'Additional Image',
    fieldName: 'product_AdditionalImage',
  },

  Product_MarketingImage: {
    fieldDisplayName: 'Marketing Image',
    fieldName: 'product_MarketingImage',
  },

  Product_Document: {
    fieldDisplayName: 'Document',
    fieldName: 'product_Document',
  },

  Product_AnyImage: {
    fieldDisplayName: 'Total Image',
    fieldName: 'product_AnyImage',
  },
  Product_Brand: {
    fieldDisplayName: 'Product Brand',
    fieldName: 'Product_Brand',
  },
  Product_UpcGtin: {
    fieldDisplayName: 'At least one UPC/GTIN field',
    fieldName: 'Product_UpcGtin',
  },
};

export const additionalRequirementFieldsLowercase = {
  product_planoimage: {
    fieldDisplayName: 'Planogram Image',
    fieldName: 'product_PlanoImage',
  },

  product_additionalimage: {
    fieldDisplayName: 'Additional Image',
    fieldName: 'product_AdditionalImage',
  },

  product_marketingimage: {
    fieldDisplayName: 'Marketing Image',
    fieldName: 'product_MarketingImage',
  },

  product_document: {
    fieldDisplayName: 'Document',
    fieldName: 'product_Document',
  },

  product_anyimage: {
    fieldDisplayName: 'Total Image',
    fieldName: 'product_AnyImage',
  },
  product_brand: {
    fieldDisplayName: 'Product Brand',
    fieldName: 'Product_Brand',
    isBoolean: true,
  },
  product_upcgtin: {
    fieldDisplayName: 'At least one UPC/GTIN field',
    fieldName: 'Product_UpcGtin',
    isBoolean: true,
  },
};
